var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnonaverageassets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/donate_coin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2068",
    d: "M2 8H4L10.2622 10.7397C11.2241 11.1605 11.6664 12.2784 11.2528 13.2434V13.2434C10.837 14.2136 9.71355 14.663 8.74342 14.2472L7 13.5",
    stroke: "#6B7DE5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2069",
    d: "M2.33541 16.3292C1.96493 16.1439 1.51442 16.2941 1.32918 16.6646C1.14394 17.0351 1.29411 17.4856 1.66459 17.6708L2.33541 16.3292ZM11.3354 13.3292L10.6646 12.9938L9.99377 14.3354L10.6646 14.6708L11.3354 13.3292ZM19.25 18C19.25 18.4142 19.5858 18.75 20 18.75C20.4142 18.75 20.75 18.4142 20.75 18H19.25ZM13.7331 15.3666L13.3977 16.0374L13.7331 15.3666ZM16.4164 16.75H18V15.25H16.4164V16.75ZM18 19.25H9.88854V20.75H18V19.25ZM6.64625 18.4846L2.33541 16.3292L1.66459 17.6708L5.97542 19.8262L6.64625 18.4846ZM14.0685 14.6957L11.3354 13.3292L10.6646 14.6708L13.3977 16.0374L14.0685 14.6957ZM9.88854 19.25C8.76302 19.25 7.65295 18.9879 6.64625 18.4846L5.97542 19.8262C7.19041 20.4337 8.53015 20.75 9.88854 20.75V19.25ZM19.25 18C19.25 18.6904 18.6904 19.25 18 19.25V20.75C19.5188 20.75 20.75 19.5188 20.75 18H19.25ZM18 16.75C18.6904 16.75 19.25 17.3096 19.25 18H20.75C20.75 16.4812 19.5188 15.25 18 15.25V16.75ZM16.4164 15.25C15.6014 15.25 14.7975 15.0602 14.0685 14.6957L13.3977 16.0374C14.335 16.506 15.3685 16.75 16.4164 16.75V15.25Z",
    fill: "#6B7DE5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 706",
    cx: 18,
    cy: 8,
    r: 4,
    stroke: "#6B7DE5",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnonaverageassets);
export default __webpack_public_path__ + "static/media/returnonaverageassets.b1d7b2ab6573430cd89dc9ce6a82401c.svg";
export { ForwardRef as ReactComponent };